import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ReactComponent as MonerisLogo } from '../../images/monerisLogo.svg'
// import LanguageListHeader from './LanguageListHeader'
import { ReactComponent as SearchIcon } from '../../images/search.svg'
import { ReactComponent as ForumsIcon } from '../../images/forums.svg'
import { ReactComponent as ChatIcon } from '../../images/chat.svg'
import { ReactComponent as StarIcon } from '../../images/star.svg'
import { ReactComponent as StarFillIcon } from '../../images/starfill.svg'
import { ReactComponent as SearchSmallIcon } from '../../images/searchsmall.svg'
// import { ReactComponent as MenuIcon } from '../../images/menu.svg'
import { ReactComponent as NavigatorIcon } from '../../images/navigator.svg'
// import styles from '../../styles/3ds2/main.module.css'
import { ECOM, CARD_PRESENT, SHOPPING_CARTS } from '../../constants/common/SideNavLists'
import  '../../css/moneris.css'

const isIE = /*@cc_on!@*/false || !!document.documentMode;

export class Header extends Component {
    state = {
        isNavOpen: false,
        openListId: -1,
        showSearch: false,
    }

    toggleOpenList(id) {
        if(this.state.openListId === id) {
            this.setState({ openListId: -1 })
        }
        else {
            this.setState({ openListId: id })
        }
    }

    renderShoppingCarts(list) {
        if(this.state.openListId === 11) {
            return (
                <div style={Styles.listCont}>
                    {
                        list.elements.map(e => {
                            return (
                                <span style={{ marginLeft: '1vw'}} className="sideNavListItem2" onClick={() => window.location.href=e.link}>{e.name}</span>
                            )
                        })
                    }
                </div>
            )
        }
    }

    renderList(list) {
        return (
            <div>
                <div style={Styles.headCont} onClick={() => this.toggleOpenList(list.id)}>
                    <span className="sideNavListItem2">{list.title}</span>
                    <i style={{ color: '#fff', fontSize: '25px'}} className={"material-icons"}>{this.state.openListId === list.id ? 'arrow_drop_up' : 'arrow_drop_down'}</i>
                </div>
                {(() => {
                    if(this.state.openListId === list.id) {
                        return (
                            <div style={Styles.listCont}>
                                {
                                    list.elements.map(e => {
                                        return (
                                            <a style={{ marginLeft: '1vw'}} className="sideNavListItem2" href={e.link}>{e.name}</a>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                })()}
            </div>
        )
    }

    constructor(props) {
        super(props);
        this.state = {value: '', showSearch:false, ifFillStar:false, headerPosition: 'relative'};
        this.wrapperRef = React.createRef();
        this.searchRef = React.createRef()
        this.searchIconRef = React.createRef()
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.updatePosition = this.updatePosition.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mouseup', this.handleClickOutside);
        document.addEventListener('wheel', this.updatePosition);
    }

    componentWillUnmount() {
        document.removeEventListener('mouseup', this.handleClickOutside);
        document.removeEventListener('wheel', this.updatePosition);
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target) && this.state.isNavOpen) {
            this.setState({ isNavOpen: false });
        }
        if (this.searchRef && !this.searchIconRef.current.contains(event.target) && !this.searchRef.current.contains(event.target) && this.state.showSearch) {
            this.setState({ showSearch: false });
        }
    }


    handleChange(text) {
        this.setState({value:text});
    }

    handleSearch(){
        let serachUrl = "https://developer.moneris.com/search?q="
        let finalUrl = serachUrl += this.state.value
        window.open( finalUrl)
    }

    renderMessage() {
        if(this.state.showSearch) {
            return (
                <div ref={this.searchRef} className="SearchBar2">
                    <input className="SearchInput2" value={this.state.value} onChange={text => {this.handleChange(text.target.value)}} ></input>
                    <div className="inputButton2" onClick={()=>{this.handleSearch()}}>
                        <SearchSmallIcon style={{marginLeft:"-1vw",marginTop:"-0.5vh"}}/>
                    </div>
                </div>
            );
        }
    }

    handleClick(){
        this.setState({showSearch:!this.state.showSearch})
        this.forceUpdate()
    }

    handleStarClick(){
        this.setState({ifFillStar:!this.state.ifFillStar})
        this.forceUpdate()
    }

    updatePosition() {
        const top = window.pageYOffset;
        const { headerPosition } = this.state;

        // console.log(mode);

        if((headerPosition === 'absolute' && top < 200)) {
            this.setState({ headerPosition: 'relative'});
        }
        else if(top >= 200 && headerPosition === 'relative') {
            this.setState({ headerPosition: 'absolute'});
        }
    }

    render() {
        return (
            <div>
                <div id="myHeader" className="mainHeader" style={{ position: this.state.headerPosition}}>
                    <div style={{display:'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                        <div style={{display:'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center'}}>
                            <div className="hamburgerIcon" onClick={() => this.setState({ isNavOpen: true })} >
                                <NavigatorIcon />
                            </div>      
                            <div className="monerisLogo2" onClick={() => window.location.href="https://developer.moneris.com"}>
                                <MonerisLogo />
                            </div>
                        </div>
                        
                        <div className="iconsContainer">
                            <div className="headerIcon2" ref={this.searchIconRef} onClick={() => this.handleClick()}>
                                <SearchIcon/>
                            </div>
                            <div className="headerIcon2" onClick={() => window.location.href="https://community.moneris.com/product-forums/"}>
                                <ForumsIcon />
                            </div>
                            <div className="headerIcon2" style={{color:"white"}} onClick={() => window.location.href="https://community.moneris.com/blogs/"}>
                                <ChatIcon />
                            </div>
                            <div className="headerIcon2" onClick={() => this.handleStarClick()}>
                                {this.state.ifFillStar? <StarFillIcon />:<StarIcon/>}
                            </div>
                        </div>
                    </div>

                    <div ref={this.searchRef} className="SearchBar2" style={{ height: this.state.showSearch ? '90px' : '0px' }} >
                        <input autoFocus className={this.state.showSearch?"SearchInput2":"NotShow2"} value={this.state.value} onChange={text => {this.handleChange(text.target.value)}} ></input>
                        <div className={this.state.showSearch?"inputButton2":"NotShow2"} onClick={()=>{this.handleSearch()}}>
                            <SearchSmallIcon style={{ width: '20px' }}/>
                        </div>
                    </div>
                </div>
                
                <div ref={this.wrapperRef} id="mySidenav" className="sidenav2" style={{ overflowY: this.state.isNavOpen ? 'auto' : 'hidden', width: this.state.isNavOpen ? '300px' : '0px' }}>
                    <span style={{ marginTop: isIE ? '0px' : '1.6vh'}} className="closebtn2" onClick={() => this.setState({ isNavOpen: false})}>&times;</span>
                    <h3 style={{ marginBottom: '0px'}} className="sideNavTitle2">Moneris Developers_</h3>

                    <div style={Styles.group}>
                        <span className="sideNavGroupTitle2">E-Commerce Solutions</span>
                        {ECOM.map(list => this.renderList(list))}
                    </div>

                    <div style={Styles.group}>
                        <span className="sideNavGroupTitle2">Card Present Solutions</span>
                        {CARD_PRESENT.map(list => this.renderList(list))}
                    </div>

                    <div style={Styles.group}>
                        <div style={Styles.headCont} onClick={() => this.toggleOpenList(11)}>
                            <span className="sideNavGroupTitle2">Shopping Carts</span>
                            <i style={{ color: '#fff', fontSize: '25px'}} className={"material-icons"}>{this.state.openListId === 11 ? 'arrow_drop_up' : 'arrow_drop_down'}</i>
                        </div>
                        {this.renderShoppingCarts(SHOPPING_CARTS[0])}
                    </div>
                </div>
            </div>
        );
    }
}

const Styles = {
    group: {
        paddingBottom: '2.5vh',
        paddingTop: '2vh',
        border: '0px solid #cacaca',
        borderBottomWidth: '1px',
        marginRight: '.5vw'
    },
    headCont: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        cursor: 'pointer'
    },
    listCont: {
        display: 'flex',
        flexDirection: 'column',
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    return { mode }
}

export default connect(mapStateToProps, {})(Header)
